import { ObrasTable } from "../obras-table";
import type { ObrasListaViewViewModel } from "./types-obras-lista-view";

/** Visão Lista: o `HubTable` consulta, pagina e ordena no servidor e mostra os estados da lista. */
export function ObrasListaViewView({
  search,
  filters,
  sort,
  settings,
  isMobile,
  onClearSearch,
  onClearFilters,
  items,
  total,
  status,
  errorMessage,
  reload,
  first,
  rows,
  handlePage,
  handleSort,
}: ObrasListaViewViewModel) {
  return (
    <ObrasTable
      items={items}
      total={total}
      first={first}
      rows={rows}
      status={status}
      errorMessage={errorMessage}
      search={search}
      filters={filters}
      sort={sort}
      settings={settings}
      isMobile={isMobile}
      onPage={handlePage}
      onSort={handleSort}
      onRetry={reload}
      onClearSearch={onClearSearch}
      onClearFilters={onClearFilters}
    />
  );
}
